import { z } from 'zod';
import { TenantIdSchema, IsoDateSchema } from './_primitives.js';

export const DRAFT_QUEUE = Object.freeze({
  AUTO_SEND:    'auto_send',
  HUMAN_REVIEW: 'human_review',
  SUPPRESSED:   'suppressed',
});

export const DraftQueueEnum = z.enum(Object.values(DRAFT_QUEUE));

export const ReplyDraftDocSchema = z.object({
  tenantId:         TenantIdSchema,
  id:               z.string().optional(),
  draftText:        z.string().min(1),
  confidence:       z.number().min(0).max(1),
  customerId:       z.string().optional(),
  inboundMessage:   z.string().optional(),
  queue:            DraftQueueEnum.optional(),
  urgency:          z.string().optional(),
  groundingTrail:   z.array(z.any()).optional(),
  missingDataFlags: z.array(z.string()).optional(),
  dataSourceSummary: z.array(z.any()).optional(),
  routing:          z.record(z.string(), z.any()).optional(),
  decisionId:       z.string().nullable().optional(),
  auditRef:         z.string().nullable().optional(),
  sentAt:           IsoDateSchema.optional(),
  isDeleted:        z.boolean().optional(),
  createdAt:        z.union([IsoDateSchema, z.object({})]).optional(),
  updatedAt:        z.union([IsoDateSchema, z.object({})]).optional(),
}).passthrough();

/** @typedef {import('zod').infer<typeof ReplyDraftDocSchema>} ReplyDraftDoc */
